import { useEffect } from "react";
import app from "nystem";

const RouterRedirects = () => {
  useEffect(() => {
    let froms = [];
    let tos = [];

    const update = async () => {
      const { data } = await app.database.redirect.search({});
      if (!data) {
        froms = [];
        tos = [];
        return;
      }

      froms = data.map(({ from }) => (from[0] === "/" ? from : `/${from}`));
      tos = data.map(({ to }) => (/^(https?:|\/)/i.test(to) ? to : `/${to}`));
      locationchange();
    };
    update();
    app.database.redirect.on("update", update);

    const locationchange = () => {
      let index = froms.indexOf(window.location.pathname);
      if (index === -1) index = froms.indexOf(window.location.pathname.replace(/(.)\/$/, "$1"));
      if (index === -1 || tos[index] === window.location.pathname) return;

      if (/^\/(?!\/)/.test(tos[index])) window.history.replaceState({}, "", tos[index]);
      else window.location.replace(tos[index]);
    };
    window.addEventListener("locationchange", locationchange);

    return () => {
      window.removeEventListener("locationchange", locationchange);
    };
  }, []);

  return null;
};

export default RouterRedirects;
